import { system } from '@workday/canvas-tokens-web'

export const Badge = {
  baseStyle: {
    textTransform: 'uppercase',
    borderRadius: 'full',
    fontWeight: 'bold',
    lineHeight: 'base',
    textAlign: 'center'
  },
  sizes: {
    sm: {
      fontSize: 'xs',
      px: 2
    },
    lg: {
      fontSize: 'sm',
      px: 3
    }
  },
  variants: {
    danger: {
      bgColor: `var(${system.color.surface.danger.strong})`,
      color: `var(${system.color.fg.danger.strong})`
    },
    pending: {
      bgColor: `var(${system.color.surface.warning.strong})`,
      color: `var(${system.color.fg.warning.strong})`
    },
    success: {
      bgColor: `var(${system.color.surface.success.strong})`,
      color: `var(${system.color.fg.success.strong})`
    },
    info: {
      bgColor: `var(${system.color.surface.info.strong})`,
      color: `var(${system.color.fg.info.strong})`
    },
    incomplete: {
      bgColor: `var(${system.color.surface.alt.strong})`,
      color: `var(${system.color.fg.muted.strong})`
    },
    complete: {
      bgColor: `var(${system.color.accent.muted.default})`,
      color: `var(${system.color.fg.inverse})`
    },
    redlinePrevious: {
      bgColor: `var(${system.color.surface.danger.strong})`,
      borderRadius: 'base',
      textDecoration: 'line-through',
      textTransform: 'capitialize',
      fontSize: 'md',
      fontWeight: 'normal',
      lineHeight: 'base'
    },
    redlineUpdated: {
      bgColor: `var(${system.color.surface.success.strong})`,
      borderRadius: 'base',
      textTransform: 'capitialize',
      fontSize: 'md',
      fontWeight: 'normal',
      lineHeight: 'base'
    }
  }
  // TODO: Commenting out default state until we move all badges to the new component (shown in storybook)
  // defaultProps: {
  //   size: 'sm',
  //   variant: 'incomplete'
  // }
}
